import { parseDateTime, toCalendarDate } from "@internationalized/date";

export function absoluteToCalendarDate(value: number) {
  return toCalendarDate(
    parseDateTime(new Date(value).toISOString().slice(0, 10)),
  );
}
